export const montantGiftCard = [
    '5000',
    '10000',
    '15000',
    '20000',
    ];